"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.endpointMapping = {
    prod: {
        apiKey: 'LIlhQH1TuHOkgaVhm54na6nzIhD8G1L6fkl9k4L2',
        endpoint: 'https://vivien.cruise-api.aida.de',
    },
    test: {
        apiKey: 'OJ0NBELhClaIPhsMuzJ4Y5us58V9Yspc8ugcAzwI',
        endpoint: 'https://test-vivien.cruise-api.aida.de',
    },
};
//# sourceMappingURL=client.js.map